import { FormatType } from '@/shared/hooks';
import { MetricDataFormatType } from './types';

export const toFormatType = (type: MetricDataFormatType): FormatType => {
  switch (type) {
    case MetricDataFormatType.INTEGER:
      return FormatType.INTEGER;
    case MetricDataFormatType.NUMERIC:
      return FormatType.FLOAT;
    case MetricDataFormatType.NUMERIC_4:
      return FormatType.FLOAT_4;
    default:
      console.warn(`Unexpected type: ${type}. Fallback to FLOAT4.`);
      return FormatType.FLOAT_4;
  }
};
